import { twMerge } from 'tailwind-merge';

export function cn(...classes: Array<string | false | undefined>): string {
  return twMerge(classes.filter(Boolean).join(' '));
}
